
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import { Box, Typography } from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';

import { useBoolean } from 'src/hooks/use-boolean';

import { WarningIcon } from './icons';

// ----------------------------------------------------------------------------

export function ConfirmationDialog({ open, onClose, onConfirm, title = 'Are you sure?', subtitle }) {

  const isSubmitting = useBoolean(false);

  const onSubmit = async () => {
    isSubmitting.onTrue();
    try {
      await onConfirm();
      onClose();
    } catch (err) {
      console.error(err);
    } finally {
      isSubmitting.onFalse();
    }
  };


  return (
    <Dialog
      fullWidth
      maxWidth="xs"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: 2,
          padding: 2,
        },
      }}
    >
      <DialogContent>
        <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
          <WarningIcon width={36} height={36} style={{ color: 'red' }} />
          <Typography variant="h6" align="center">
            {title}
          </Typography>

          <Typography variant="subtitle1" align="center">
            {subtitle}
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center', paddingBottom: 2 }}>
        <Button variant="outlined" color="inherit" onClick={onClose} sx={{ minWidth: 80 }}>
          No
        </Button>
        <LoadingButton
          variant="contained"
          color="error"
          onClick={onSubmit}
          loading={isSubmitting.value}
          sx={{ minWidth: 80 }}
        >
          Yes
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}
